// Weekday keys shared by the server and the web, kept free of runtime deps (zod) so that
// importing them from the web doesn't pull the schema library into the main bundle.
export const WEEKDAYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const;
export type WeekdayKey = (typeof WEEKDAYS)[number];
